/* ==========================================================================
   Catchy Search — instant, typo-tolerant, bilingual product search
   No dependencies. Index is built from /collections/all?view=catchy-index
   and cached in the browser for 6 hours.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.getElementById('cs-root');
  if (!root || root.__cs) return;
  root.__cs = true;

  var cfg = JSON.parse(root.querySelector('.cs-config').textContent);
  var T = cfg.t;
  var WORKER = (cfg.worker || '').replace(/\/+$/, '');
  var $ = function (s) { return root.querySelector(s); };

  var el = {
    bar: $('.cs-bar'), input: $('.cs-input'), clear: $('.cs-clear'), voice: $('.cs-voice'),
    camera: $('.cs-camera'), file: $('.cs-file'), panel: $('.cs-panel'), scroll: $('.cs-scroll'),
    home: $('.cs-home'), recent: $('.cs-recent'), recentList: $('.cs-recent-list'), recentClear: $('.cs-recent-clear'),
    popular: $('.cs-popular-list'), results: $('.cs-results'), sugg: $('.cs-sugg'),
    catsBlock: $('.cs-cats-block'), cats: $('.cs-cats'), dym: $('.cs-didyoumean'),
    count: $('.cs-count'), viewAll: $('.cs-viewall'), grid: $('.cs-grid'), more: $('.cs-more'),
    empty: $('.cs-empty'), emptyTitle: $('.cs-empty-title'),
    photo: $('.cs-photo'), photoThumb: $('.cs-photo-thumb'), photoStatus: $('.cs-photo-status'),
    photoTerms: $('.cs-photo-terms'), photoClose: $('.cs-photo-close')
  };

  /* ---------------------------------------------------------------- utils */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k)); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function sstore(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k)); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function money(cents) {
    var a = (Number(cents) || 0) / 100, f = cfg.money || '{{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(a).toLocaleString('en');
      if (k === 'amount_with_comma_separator') return a.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(a).toLocaleString('de');
      return a.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }
  function timeout(p, ms) { return Promise.race([p, new Promise(function (_, r) { setTimeout(function () { r(new Error('timeout')); }, ms); })]); }

  /* ------------------------------------------------------ text normalizing */
  var AR = {
    'كفر': 'case', 'كفرات': 'case', 'جراب': 'case', 'غطاء': 'case', 'كفه': 'case', 'كوفر': 'case', 'كفرين': 'case',
    'شاحن': 'charger', 'شواحن': 'charger', 'راس': 'adapter', 'باور': 'power', 'بنك': 'bank', 'باوربانك': 'power bank', 'بطاريه': 'power bank',
    'سماعه': 'earbuds', 'سماعات': 'earbuds', 'ايربودز': 'airpods', 'ايربود': 'airpods', 'هيدفون': 'headphones',
    'ساعه': 'watch', 'ساعات': 'watch', 'سوار': 'band', 'حزام': 'band', 'قشاط': 'band', 'استيك': 'band',
    'كيبل': 'cable', 'كابل': 'cable', 'وصله': 'cable', 'شريط': 'cable', 'لاصقه': 'protector', 'حمايه': 'protector',
    'شاشه': 'screen', 'زجاج': 'glass', 'حامل': 'holder', 'ستاند': 'stand', 'سياره': 'car', 'سيارات': 'car',
    'ايفون': 'iphone', 'سامسونج': 'samsung', 'سامسونغ': 'samsung', 'جالكسي': 'galaxy', 'ايباد': 'ipad', 'ماك': 'macbook', 'ماكبوك': 'macbook', 'لابتوب': 'laptop',
    'قلم': 'pencil', 'حقيبه': 'bag', 'شنطه': 'bag', 'شنط': 'bag', 'محفظه': 'wallet', 'جزدان': 'wallet',
    'مايك': 'microphone', 'مايكروفون': 'microphone', 'ميكروفون': 'microphone', 'سبيكر': 'speaker', 'مكبر': 'speaker', 'سماعه بلوتوث': 'speaker',
    'كاميرا': 'camera', 'عدسه': 'lens', 'ماوس': 'mouse', 'فاره': 'mouse', 'كيبورد': 'keyboard', 'لوحه': 'keyboard',
    'ضوء': 'light', 'اضاءه': 'light', 'رنج': 'ring', 'ختم': 'stamp', 'تراكر': 'tag', 'مفتاح': 'tag',
    'برو': 'pro', 'ماكس': 'max', 'الترا': 'ultra', 'بلس': 'plus', 'ميني': 'mini', 'اير': 'air', 'فولد': 'fold', 'فليب': 'flip',
    'اسود': 'black', 'ابيض': 'white', 'شفاف': 'clear', 'ازرق': 'blue', 'احمر': 'red', 'وردي': 'pink', 'زهري': 'pink', 'اخضر': 'green', 'بنفسجي': 'purple', 'ذهبي': 'gold', 'فضي': 'silver', 'بني': 'brown',
    'جلد': 'leather', 'جلدي': 'leather', 'مغناطيسي': 'magnetic', 'مغناطيس': 'magnetic', 'ماجسيف': 'magsafe', 'ماغسيف': 'magsafe', 'لاسلكي': 'wireless', 'سريع': 'fast',
    'تايب': 'type', 'سي': 'c', 'لايتنينج': 'lightning', 'لايتننغ': 'lightning', 'مرايه': 'mirror', 'اسم': 'name', 'مخصص': 'customized', 'تصميم': 'design',
    'انكر': 'anker', 'ويوو': 'wiwu', 'جوي روم': 'joyroom', 'جويروم': 'joyroom', 'ابل': 'apple', 'بلوتوث': 'bluetooth'
  };
  var SYN = {
    cover: ['case'], skin: ['case'], earphone: ['earbud', 'earphone'], earpod: ['earbud', 'airpod'], earbud: ['earbud', 'earphone'],
    headset: ['headphone', 'headset'], headphone: ['headphone', 'headset'], charger: ['charger', 'adapter'], adapter: ['adapter', 'charger'],
    protector: ['protector', 'glass'], glass: ['glass', 'protector'], strap: ['band', 'strap'], band: ['band', 'strap', 'loop'],
    holder: ['holder', 'mount'], mount: ['mount', 'holder'], mic: ['microphone', 'mic'], pencil: ['pencil', 'stylus', 'pen'], pen: ['pen', 'stylus', 'pencil'], stylus: ['stylus', 'pencil', 'pen'],
    bag: ['bag', 'pouch', 'backpack'], pouch: ['pouch', 'bag'], wire: ['cable'], cord: ['cable'], tracker: ['tag', 'tracker'], airtag: ['tag', 'airtag'],
    galaxy: ['samsung', 'galaxy'], apple: ['apple', 'iphone'], speaker: ['speaker', 'soundcore'], magnet: ['magnetic', 'magsafe'], magnetic: ['magnetic', 'magsafe']
  };
  var STOP = { 'for': 1, 'the': 1, 'with': 1, 'and': 1, 'of': 1, 'to': 1, 'in': 1, 'a': 1, 'an': 1, 'من': 1, 'ل': 1, 'على': 1, 'مع': 1, 'في': 1, 'و': 1, 'عن': 1 };

  function baseNorm(s) {
    return String(s || '').toLowerCase().normalize('NFKD')
      .replace(/[̀-ًͯ-ٰٟـ]/g, '')
      .replace(/[أإآٱ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي')
      .replace(/[٠-٩]/g, function (d) { return d.charCodeAt(0) - 1632; })
      .replace(/[^\p{L}\p{N}]+/gu, ' ');
  }
  /* Rewrite shorthand people type for phone models & product words */
  function rewrite(s) {
    return (' ' + s + ' ')
      .replace(/\b([a-z]{3,})(\d)/g, '$1 $2')
      .replace(/\b(\d{2})(pm|promax)\b/g, '$1 pro max').replace(/\b(\d{2})p\b/g, '$1 pro')
      .replace(/\bs(\d{2})u\b/g, 's$1 ultra').replace(/\bs(\d{2})\s?ultra\b/g, 's$1 ultra').replace(/\bs(\d{2})(plus|\+)/g, 's$1 plus')
      .replace(/\bpromax\b/g, 'pro max').replace(/\bpowerbanks?\b/g, 'power bank').replace(/\bmag ?safe\b/g, 'magsafe')
      .replace(/\bair ?pods?\b/g, 'airpod').replace(/\btype ?c\b/g, 'typec').replace(/\busb ?c\b/g, 'typec').replace(/\bscreen ?protectors?\b/g, 'screen protector')
      .replace(/\b(\d+) ?w\b/g, '$1w').replace(/\b(\d+) ?mah\b/g, '$1mah').replace(/\b(\d+) ?mm\b/g, '$1mm')
      .replace(/\s+/g, ' ').trim();
  }
  function stem(t) {
    if (t.length > 4 && /[a-z]$/.test(t)) {
      if (/ies$/.test(t)) return t.slice(0, -3) + 'y';
      if (/(ches|shes|sses|xes)$/.test(t)) return t.slice(0, -2);
      if (/s$/.test(t) && !/ss$/.test(t)) return t.slice(0, -1);
    }
    return t;
  }
  function arabicMap(tok) {
    if (!/[؀-ۿ]/.test(tok)) return tok;
    if (AR[tok]) return AR[tok];
    var t = tok.replace(/^(وال|بال|لل|ال|و)/, '');
    if (AR[t]) return AR[t];
    var t2 = t.replace(/(ات|ين|ون|ه)$/, '');
    return AR[t2] || t;
  }
  function tokens(s, isQuery) {
    var n = baseNorm(s);
    if (isQuery) {
      Object.keys(AR).forEach(function (k) { if (k.indexOf(' ') > 0 && n.indexOf(k) > -1) n = n.split(k).join(AR[k]); });
      n = n.split(' ').map(arabicMap).join(' ');
    }
    n = rewrite(n);
    var out = [];
    n.split(' ').forEach(function (t) { if (t && !(isQuery && STOP[t])) out.push(stem(t)); });
    return out;
  }

  /* -------------------------------------------------------------- the index */
  var IDX = null, loading = null;
  var F = { TITLE: 3.2, VENDOR: 2.6, OPT: 1.6, TYPE: 2, TAG: 1 };

  function build(rows, cols) {
    var docs = [], inv = new Map();
    function add(tok, i, w) {
      var m = inv.get(tok);
      if (!m) { m = new Map(); inv.set(tok, m); }
      if ((m.get(i) || 0) < w) m.set(i, w);
    }
    rows.forEach(function (r, i) {
      var opts = {};
      String(r[10] || '').split(';').forEach(function (part) {
        var k = part.indexOf(':'); if (k < 1) return;
        var vals = part.slice(k + 1).split('|').map(function (v) { return v.trim(); }).filter(Boolean);
        if (vals.length) opts[part.slice(0, k).trim()] = vals;
      });
      var d = { i: i, rank: i, id: r[0], title: r[1], handle: r[2], vendor: r[3], type: r[4], tags: r[5] ? String(r[5]).split(' ') : [], price: r[6], compare: r[7], img: r[8], avail: !!r[9], opts: opts, created: r[11] || 0, priceMax: r[12] || r[6], nt: rewrite(baseNorm(r[1])) };
      docs.push(d);
      tokens(r[1]).forEach(function (t, k) { add(t, i, F.TITLE + (k === 0 ? 0.3 : 0)); });
      tokens(r[3]).forEach(function (t) { add(t, i, F.VENDOR); });
      tokens(r[4]).forEach(function (t) { add(t, i, F.TYPE); });
      tokens(r[10]).forEach(function (t) { add(t, i, F.OPT); });
      tokens(r[5]).forEach(function (t) { add(t, i, F.TAG); });
    });
    var vocab = Array.from(inv.keys()).sort();
    var byLen = {};
    vocab.forEach(function (t) { (byLen[t.length] = byLen[t.length] || []).push(t); });
    var colsArr = (cols || []).filter(Boolean).map(function (c) { return { title: c[0], handle: c[1], n: c[2], nt: baseNorm(c[0]) }; });
    var vendors = {};
    docs.forEach(function (d) { if (d.vendor) vendors[d.vendor] = (vendors[d.vendor] || 0) + 1; });
    IDX = { docs: docs, inv: inv, vocab: vocab, byLen: byLen, cols: colsArr, vendors: vendors };
    return IDX;
  }

  function loadIndex() {
    if (IDX) return Promise.resolve(IDX);
    if (loading) return loading;
    var key = 'cs-index:' + cfg.locale + ':v3';
    var cached = store(key);
    if (cached && cached.rows && Date.now() - cached.t < 6 * 3600e3) {
      build(cached.rows, cached.cols);
      if (Date.now() - cached.t > 30 * 60e3) setTimeout(function () { fetchAll(key).catch(function () {}); }, 4000);
      return Promise.resolve(IDX);
    }
    loading = fetchAll(key).then(function (d) { return build(d.rows, d.cols); }).catch(function (e) { loading = null; throw e; });
    return loading;
  }
  function fetchPage(n) {
    var sep = cfg.indexUrl.indexOf('?') > -1 ? '&' : '?';
    return fetch(cfg.indexUrl + sep + 'page=' + n, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function fetchAll(key) {
    return fetchPage(1).then(function (first) {
      var rest = [], all = [first], i = 2;
      function worker() {
        if (i > first.pages) return Promise.resolve();
        var n = i++;
        return fetchPage(n).then(function (p) { all.push(p); return worker(); });
      }
      for (var k = 0; k < 6; k++) rest.push(worker());
      return Promise.all(rest).then(function () {
        all.sort(function (a, b) { return a.page - b.page; });
        var rows = [];
        all.forEach(function (p) { rows = rows.concat(p.items); });
        var d = { t: Date.now(), rows: rows, cols: first.collections || [] };
        store(key, d);
        return d;
      });
    });
  }

  /* ----------------------------------------------------------- matching */
  function dist(a, b, max) { /* Damerau (OSA) distance with early exit */
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev2 = null, prev = [], cur;
    for (var j = 0; j <= lb; j++) prev[j] = j;
    for (var i = 1; i <= la; i++) {
      cur = [i]; var rowMin = i;
      for (j = 1; j <= lb; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v; if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[lb];
  }
  function lowerBound(arr, t) { var lo = 0, hi = arr.length; while (lo < hi) { var m = (lo + hi) >> 1; if (arr[m] < t) lo = m + 1; else hi = m; } return lo; }

  /* Returns [{tok, q, kind}] vocab tokens that a query token may refer to */
  function expand(qt, isLast) {
    var out = [], seen = {}, hasDigit = /\d/.test(qt);
    function push(tok, q, kind) { if (!seen[tok] || seen[tok].q < q) { seen[tok] = { tok: tok, q: q, kind: kind }; } }
    var alts = [qt].concat(SYN[qt] || []);
    alts.forEach(function (a, ai) {
      var base = ai === 0 ? 1 : 0.85;
      if (IDX.inv.has(a)) push(a, base, 'exact');
      if ((isLast && a.length >= 1) || a.length >= 4) {
        var start = lowerBound(IDX.vocab, a), c = 0;
        for (var i = start; i < IDX.vocab.length && c < 80; i++) {
          var v = IDX.vocab[i];
          if (v.indexOf(a) !== 0) break;
          if (v !== a) { push(v, base * (isLast ? 0.86 : 0.72) - Math.min(0.15, (v.length - a.length) * 0.01), 'prefix'); c++; }
        }
      }
    });
    var exactFound = Object.keys(seen).some(function (k) { return seen[k].kind === 'exact'; });
    if (!exactFound && !hasDigit && qt.length >= 3) {
      var max = qt.length <= 4 ? 1 : 2;
      for (var L = qt.length - max; L <= qt.length + max; L++) {
        (IDX.byLen[L] || []).forEach(function (v) {
          if (/\d/.test(v)) return;
          if (qt.length <= 4 && v[0] !== qt[0]) return;
          var d = dist(qt, v, max);
          if (d <= max) push(v, 0.66 - d * 0.12, 'fuzzy');
        });
      }
      if (isLast && qt.length >= 4) { /* typo inside a word still being typed */
        IDX.vocab.forEach(function (v) {
          if (v.length > qt.length + 1 && v[0] === qt[0] && !seen[v] && dist(qt, v.slice(0, qt.length), 1) <= 1) push(v, 0.55, 'fuzzy');
        });
      }
    }
    return Object.keys(seen).map(function (k) { return seen[k]; });
  }

  function search(raw, limit) {
    var qts = tokens(raw, true);
    if (!qts.length) return { items: [], total: 0, correction: null };
    var per = [], correction = [], corrected = false;
    qts.forEach(function (qt, i) {
      var cands = expand(qt, i === qts.length - 1);
      var m = new Map(), best = null;
      cands.forEach(function (c) {
        if (!best || c.q > best.q || (c.q === best.q && c.kind === 'exact')) best = c;
        IDX.inv.get(c.tok).forEach(function (w, d) { var s = w * c.q; if ((m.get(d) || 0) < s) m.set(d, s); });
      });
      if (best && best.kind === 'fuzzy') { corrected = true; correction.push(best.tok); } else correction.push(qt);
      per.push(m);
    });
    var need = per.length, scores = new Map(), counts = new Map();
    per.forEach(function (m) { m.forEach(function (s, d) { scores.set(d, (scores.get(d) || 0) + s); counts.set(d, (counts.get(d) || 0) + 1); }); });
    var pick = function (min) { var r = []; counts.forEach(function (c, d) { if (c >= min) r.push(d); }); return r; };
    var ids = pick(need), relaxed = false;
    if (!ids.length && need > 1) { ids = pick(need - 1); relaxed = true; }
    var qn = rewrite(baseNorm(raw));
    var res = ids.map(function (d) {
      var doc = IDX.docs[d], s = scores.get(d);
      if (doc.nt.indexOf(qn) === 0) s += 4; else if (doc.nt.indexOf(qn) > -1) s += 2.5;
      s *= doc.avail ? 1.25 : 0.55;
      s += Math.max(0, 1.2 - doc.rank / 800);
      return { d: doc, s: s };
    }).sort(function (a, b) { return b.s - a.s; });
    return {
      all: res.map(function (x) { x.d._score = x.s; return x.d; }),
      items: res.slice(0, limit || 8).map(function (x) { return x.d; }), total: res.length, relaxed: relaxed,
      tokens: qts, correction: corrected ? correction.join(' ') : null
    };
  }

  /* Text suggestions: popular terms, brand & category matches, and completions */
  function suggestions(raw, res) {
    var q = baseNorm(raw).trim(), qr = rewrite(q), out = [], seen = {};
    function add(text, kind) { var k = baseNorm(text).trim(); if (!k || seen[k] || k === q) return; seen[k] = 1; out.push({ text: text, kind: kind }); }
    popularTerms.forEach(function (p) { var n = baseNorm(p); if (n.indexOf(q) === 0 || n.indexOf(' ' + q) > -1 || rewrite(n).indexOf(qr) === 0) add(p, 'popular'); });
    if (IDX) {
      Object.keys(IDX.vendors).forEach(function (v) { var n = baseNorm(v); if (q.length >= 2 && n.indexOf(q.split(' ')[0]) === 0) add(v, 'brand'); });
      var last = res.tokens && res.tokens[res.tokens.length - 1];
      if (last && last.length >= 2 && res.tokens.length <= 3) { /* complete the phrase from top results */
        var base = (res.correction || res.tokens.join(' ')).split(' ');
        var prefix = base.slice(0, -1).join(' '), lastWord = base[base.length - 1];
        res.items.slice(0, 6).forEach(function (d) {
          var words = d.nt.split(' '), idx = words.findIndex(function (w) { return w.indexOf(lastWord) === 0; });
          if (idx > -1) add((prefix ? prefix + ' ' : '') + words.slice(idx, idx + 2).join(' '), 'complete');
        });
      }
    }
    return out.slice(0, 7);
  }
  function categories(raw) {
    if (!IDX || !IDX.cols.length) return [];
    var qts = tokens(raw, true);
    return IDX.cols.map(function (c) {
      var hit = 0;
      qts.forEach(function (t) { if ((' ' + rewrite(c.nt)).indexOf(' ' + t) > -1) hit++; });
      return { c: c, hit: hit };
    }).filter(function (x) { return x.hit > 0; })
      .sort(function (a, b) { return b.hit - a.hit || b.c.n - a.c.n; }).slice(0, 4).map(function (x) { return x.c; });
  }

  /* Fallback while the index loads: Shopify's own predictive search */
  function shopifySuggest(q) {
    var u = cfg.root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    return fetch(u).then(function (r) { return r.json(); }).then(function (j) {
      var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
      return {
        items: ps.map(function (p) {
          return { title: p.title, handle: p.handle, url: p.url, img: p.image || (p.featured_image && p.featured_image.url) || '', price: Math.round(parseFloat(p.price) * 100), compare: Math.round(parseFloat(p.compare_at_price_max || 0) * 100), avail: p.available !== false, nt: rewrite(baseNorm(p.title)) };
        }), total: ps.length, tokens: tokens(q, true), correction: null, fallback: true
      };
    });
  }

  /* ------------------------------------------------------------ rendering */
  function productUrl(d) { return d.url || (cfg.root.replace(/\/$/, '') + '/products/' + d.handle); }
  function highlight(title, qtoks) {
    var nt = baseNorm(title);
    if (nt.length !== title.length) return esc(title);
    var marks = new Array(title.length).fill(false);
    (qtoks || []).forEach(function (t) {
      if (t.length < 2) return;
      var re = new RegExp('(^|\\s)' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), m;
      while ((m = re.exec(nt))) { var s = m.index + m[1].length; for (var i = s; i < s + t.length && i < title.length; i++) marks[i] = true; }
    });
    var h = '', open = false;
    for (var i = 0; i < title.length; i++) {
      if (marks[i] && !open) { h += '<mark>'; open = true; }
      if (!marks[i] && open) { h += '</mark>'; open = false; }
      h += esc(title[i]);
    }
    return open ? h + '</mark>' : h;
  }
  function imgUrl(u, w) { if (!u) return ''; return u.replace(/([?&])width=\d+/, '$1width=' + w); }
  function card(d, qtoks) {
    var sale = d.compare > d.price, pct = sale ? Math.round((1 - d.price / d.compare) * 100) : 0;
    var badge = !d.avail ? '<span class="cs-badge cs-badge--out">' + esc(T.soldOut) + '</span>' : (sale && pct >= 5 ? '<span class="cs-badge">-' + pct + '%</span>' : '');
    if (state.exactId && String(d.id) === state.exactId) badge += '<span class="cs-badge cs-badge--match" style="inset-inline-start:auto;inset-inline-end:12px;background:#2e9e7b">✓ ' + esc(T.exact || (cfg.locale === 'ar' ? 'تطابق تام' : 'Exact match')) + '</span>';
    var img = d.img ? '<img src="' + esc(imgUrl(d.img, 240)) + '" srcset="' + esc(imgUrl(d.img, 240)) + ' 1x, ' + esc(imgUrl(d.img, 400)) + ' 2x" alt="" width="120" height="120" decoding="async" onload="this.parentNode.classList.add(\'is-loaded\')" onerror="this.remove()">' : '';
    return '<a class="cs-card' + (d.avail ? '' : ' is-out') + '" href="' + esc(productUrl(d)) + '" data-cs-nav data-cs-product="' + esc(d.handle) + '">' + badge +
      '<span class="cs-img">' + img + '</span>' +
      '<span class="cs-title product-item-meta__title">' + highlight(d.title, qtoks) + '</span>' +
      '<span class="cs-price price-list price-list--centered">' + (sale
        ? '<span class="price price--highlight">' + esc(money(d.price)) + '</span><span class="price price--compare">' + esc(money(d.compare)) + '</span>'
        : '<span class="price">' + esc(money(d.price)) + '</span>') + '</span></a>';
  }
  var ICON_SEARCH = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.6-3.6"/></svg>';
  var ICON_TREND = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17l6-6 4 4 8-8"/><path d="M14 7h7v7"/></svg>';
  var ICON_TAG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12l-8 8-9-9V3h8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  function boldPrefix(text, q) {
    var n = baseNorm(text), qn = baseNorm(q).trim();
    if (n.length === text.length && qn && n.indexOf(qn) === 0) return esc(text.slice(0, qn.length)) + '<strong>' + esc(text.slice(qn.length)) + '</strong>';
    return esc(text);
  }

  var state = { q: '', shown: 8, res: null, photo: null, seq: 0 };
  /* Two full rows of results: 6 / 5 / 4 columns on desktop, 2 on mobile */
  function baseShown() {
    if (!root.classList.contains('cs--docked')) return 8;
    var w = window.innerWidth;
    return w >= 1400 ? 12 : w >= 1200 ? 10 : 8;
  }

  function showHome() {
    root.dataset.state = 'home';
    el.home.hidden = false; el.results.hidden = true;
    renderRecent();
  }
  function renderResults(raw, res) {
    root.dataset.state = 'results';
    el.home.hidden = true; el.results.hidden = false;
    state.res = res;
    var sugg = res.fallback ? [] : suggestions(raw, res);
    el.sugg.innerHTML = sugg.map(function (s) {
      return '<li><button type="button" data-cs-term="' + esc(s.text) + '" data-cs-nav>' + (s.kind === 'popular' ? ICON_TREND : ICON_SEARCH) + '<span>' + boldPrefix(s.text, raw) + '</span></button></li>';
    }).join('');
    el.sugg.closest('.cs-block').hidden = !sugg.length;
    var cats = res.fallback ? [] : categories(raw);
    el.cats.innerHTML = cats.map(function (c) {
      return '<li><a href="' + esc(cfg.root.replace(/\/$/, '') + '/collections/' + c.handle) + '" data-cs-nav>' + ICON_TAG + '<span>' + esc(c.title) + '</span><span class="cs-n">' + c.n + '</span></a></li>';
    }).join('');
    el.catsBlock.hidden = !cats.length;

    if (res.correction && res.correction !== tokens(raw, true).join(' ')) {
      el.dym.hidden = false;
      el.dym.innerHTML = esc(T.didYouMean) + ' <button type="button" data-cs-term="' + esc(res.correction) + '">' + esc(res.correction) + '</button>?';
    } else el.dym.hidden = true;

    var label = state.photo ? state.photo.label : raw;
    if (!res.items.length) {
      el.grid.innerHTML = ''; el.more.hidden = true; el.empty.hidden = false;
      el.emptyTitle.textContent = T.noResults + ' “' + label + '”';
      el.count.innerHTML = ''; el.viewAll.hidden = true;
      return;
    }
    el.empty.hidden = true;
    el.count.innerHTML = (res.relaxed ? esc(T.close) + ' · ' : '') + '<em>' + res.total + '</em> ' + esc(T.results);
    el.viewAll.hidden = !!state.photo;
    el.viewAll.textContent = T.viewAll + ' →';
    el.viewAll.href = searchPageUrl(res.correction && !res.relaxed && res.total ? res.correction : raw);
    el.grid.innerHTML = res.items.map(function (d) { return card(d, res.tokens); }).join('');
    el.more.hidden = res.fallback || res.total <= res.items.length || res.items.length >= 48;
    el.more.textContent = T.more + ' (' + (res.total - res.items.length) + ')';
  }
  function searchPageUrl(q) { return cfg.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }

  /* -------------------------------------------------------------- run search */
  var typingTimer, logTimer;
  function run(raw, opts) {
    opts = opts || {};
    raw = String(raw || '');
    state.q = raw;
    var q = raw.trim();
    el.clear.hidden = !raw;
    if (!q) { clearPhoto(); showHome(); return; }
    var seq = ++state.seq;
    if (IDX) {
      var res = search(q, state.shown);
      renderResults(q, res);
      scheduleLog(q, res.total);
    } else {
      shopifySuggest(q).then(function (res) { if (seq === state.seq && !IDX) renderResults(q, res); }).catch(function () {});
      loadIndex().then(function () { if (seq === state.seq) run(state.q, opts); }).catch(function () {});
    }
  }

  /* --------------------------------------------------- recent & popular */
  var RKEY = 'cs-recent';
  function recent() { return store(RKEY) || []; }
  function remember(q) {
    q = String(q || '').trim(); if (q.length < 2) return;
    var r = recent().filter(function (x) { return baseNorm(x) !== baseNorm(q); });
    r.unshift(q); store(RKEY, r.slice(0, 6));
  }
  function renderRecent() {
    var r = recent();
    el.recent.hidden = !r.length;
    el.recentList.innerHTML = r.map(function (q) {
      return '<span class="cs-chip cs-chip--recent" data-cs-term="' + esc(q) + '" data-cs-nav role="button" tabindex="0">' + esc(q) +
        '<span class="cs-chip-x" data-cs-forget="' + esc(q) + '" aria-label="Remove">×</span></span>';
    }).join('');
  }
  var popularTerms = Array.prototype.map.call(el.popular.querySelectorAll('[data-cs-term]'), function (b) { return b.dataset.csTerm; });
  function loadPopular() {
    if (!WORKER) return;
    var cached = sstore('cs-popular:' + cfg.locale);
    var apply = function (list) {
      if (!list || !list.length) return;
      var merged = [], seen = {};
      list.concat(popularTerms).forEach(function (t) { var k = baseNorm(t).trim(); if (k && !seen[k]) { seen[k] = 1; merged.push(t); } });
      popularTerms = merged.slice(0, 10);
      el.popular.innerHTML = popularTerms.map(function (t, i) {
        return '<button type="button" class="cs-chip" data-cs-term="' + esc(t) + '" data-cs-nav>' + (i < 3 ? '<span class="cs-fire" aria-hidden="true">🔥</span>' : '') + esc(t) + '</button>';
      }).join('');
    };
    if (cached) return apply(cached);
    timeout(fetch(WORKER + '/popular?locale=' + encodeURIComponent(cfg.locale)), 3000)
      .then(function (r) { return r.json(); })
      .then(function (j) { var list = (j.terms || []).map(function (x) { return x.q || x; }); sstore('cs-popular:' + cfg.locale, list); apply(list); })
      .catch(function () {});
  }
  var lastLogged = '';
  function sendLog(q, n, source) {
    if (!WORKER) return;
    q = String(q || '').trim().toLowerCase().slice(0, 80);
    if (q.length < 2 || q === lastLogged) return;
    lastLogged = q;
    var body = JSON.stringify({ q: q, n: n, locale: cfg.locale, src: source || 'type' });
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(WORKER + '/log', new Blob([body], { type: 'text/plain' }));
      else fetch(WORKER + '/log', { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } });
    } catch (e) {}
  }
  function scheduleLog(q, n) {
    clearTimeout(logTimer);
    if (q.length >= 3) logTimer = setTimeout(function () { sendLog(q, n, 'type'); }, 2200);
  }

  /* ---------------------------------------------------------- open / close */
  var desktop = window.matchMedia('(min-width: 1000px)');
  function isOpen() { return root.classList.contains('is-open'); }
  function open(focus) {
    if (!desktop.matches && !root.classList.contains('cs--docked')) {
      if (root.parentNode !== document.body) document.body.appendChild(root); /* escape the header's layer */
      root.style.zIndex = '2147483000';                                      /* above announcement bar & chat widgets */
      root.classList.add('cs--sheet');
      document.documentElement.classList.add('cs-lock');
    }
    root.classList.add('is-open');
    placePanel();
    if (state.shown < baseShown()) state.shown = baseShown();
    el.panel.hidden = false;
    el.input.setAttribute('aria-expanded', 'true');
    run(el.input.value);
    loadIndex().catch(function () {});
    loadPopular();
    if (focus) setTimeout(function () { el.input.focus({ preventScroll: true }); }, 30);
  }
  function close() {
    root.classList.remove('is-open', 'cs--sheet', 'is-dragging');
    document.documentElement.classList.remove('cs-lock');
    el.panel.hidden = true;
    el.input.setAttribute('aria-expanded', 'false');
    setActive(-1);
    if (document.activeElement === el.input && !desktop.matches) el.input.blur();
  }
  /* Desktop: the panel spans the full width right under the search bar */
  function placePanel() {
    if (!root.classList.contains('cs--docked')) return;
    var b = el.bar.getBoundingClientRect();
    root.style.setProperty('--cs-top', Math.round(b.bottom + 12) + 'px');
  }
  window.addEventListener('scroll', function () { if (isOpen()) placePanel(); }, { passive: true });
  window.addEventListener('resize', function () { if (isOpen()) placePanel(); }, { passive: true });
  /* Keep the single box in the right place when the screen size changes */
  function placeBox() {
    var slot = document.querySelector('[data-cs-slot]');
    if (desktop.matches && slot && root.parentNode !== slot) { close(); slot.appendChild(root); root.classList.add('cs--docked'); }
    else if (!desktop.matches && root.parentNode !== document.body) { close(); document.body.appendChild(root); root.classList.remove('cs--docked'); }
  }
  (desktop.addEventListener ? desktop.addEventListener('change', placeBox) : desktop.addListener(placeBox));
  placeBox();

  /* ------------------------------------------------------- keyboard nav */
  var active = -1;
  function navItems() { return Array.prototype.filter.call(root.querySelectorAll('[data-cs-nav]'), function (n) { return n.offsetParent !== null; }); }
  function setActive(i) {
    var items = navItems();
    items.forEach(function (n) { n.classList.remove('is-active'); });
    active = i;
    if (i >= 0 && items[i]) { items[i].classList.add('is-active'); items[i].scrollIntoView({ block: 'nearest' }); }
  }

  function submit(q, source) {
    q = String(q || '').trim(); if (!q) return;
    remember(q);
    var res = state.res, target = q;
    if (res && res.correction && !res.relaxed && res.total) target = res.correction;
    sendLog(q, res ? res.total : -1, source || 'submit');
    window.location.href = searchPageUrl(target);
  }

  /* ------------------------------------------------------------- events */
  el.bar.addEventListener('submit', function (e) { e.preventDefault(); submit(el.input.value); });
  el.input.addEventListener('focus', function () { if (!isOpen()) open(false); });
  el.input.addEventListener('input', function () {
    clearPhoto(); state.shown = baseShown();
    clearTimeout(typingTimer);
    var v = el.input.value;
    typingTimer = setTimeout(function () { run(v); setActive(-1); }, IDX ? 25 : 120);
  });
  el.input.addEventListener('keydown', function (e) {
    var items = navItems();
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(items.length - 1, active + 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(-1, active - 1)); }
    else if (e.key === 'Enter') {
      if (active >= 0 && items[active]) { e.preventDefault(); items[active].click(); }
    } else if (e.key === 'Escape') { if (el.input.value) { el.input.value = ''; run(''); } else close(); }
  });
  el.clear.addEventListener('click', function () { el.input.value = ''; clearPhoto(); run(''); el.input.focus(); });

  root.addEventListener('click', function (e) {
    var forget = e.target.closest('[data-cs-forget]');
    if (forget) {
      e.stopPropagation();
      store(RKEY, recent().filter(function (x) { return x !== forget.dataset.csForget; }));
      renderRecent(); return;
    }
    var term = e.target.closest('[data-cs-term]');
    if (term) {
      var t = term.dataset.csTerm;
      /* Popular, recent and suggested searches open the full results page */
      if (term.closest('.cs-popular-list, .cs-recent-list, .cs-sugg-block')) {
        remember(t); sendLog(t, -1, 'chip');
        close(); window.location.href = searchPageUrl(t);
        return;
      }
      el.input.value = t; clearPhoto(); state.shown = baseShown(); run(t); remember(t); sendLog(t, state.res ? state.res.total : -1, 'chip');
      if (desktop.matches) el.input.focus();
      return;
    }
    var prod = e.target.closest('[data-cs-product]');
    if (prod) { remember(state.photo ? '' : el.input.value); sendLog(el.input.value, state.res ? state.res.total : -1, 'click'); return; }
    if (e.target.closest('[data-cs-close]')) { close(); }
  });
  el.recentClear.addEventListener('click', function () { store(RKEY, []); renderRecent(); });
  el.more.addEventListener('click', function () {
    state.shown = Math.min(48, state.shown + baseShown());
    if (state.photo) runPhotoTerms(state.photo); else run(state.q);
  });
  el.viewAll.addEventListener('click', function () { remember(el.input.value); sendLog(el.input.value, state.res ? state.res.total : -1, 'viewall'); });

  /* Close when clicking outside (desktop) */
  document.addEventListener('mousedown', function (e) { if (isOpen() && root.classList.contains('cs--docked') && !root.contains(e.target)) close(); });
  /* Open from header icons / keyboard shortcuts */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cs-open], a[aria-controls="search-drawer"], button[aria-controls="search-drawer"]');
    if (t && !root.contains(t)) { e.preventDefault(); e.stopPropagation(); open(true); }
  }, true);
  document.addEventListener('keydown', function (e) {
    var typing = /input|textarea|select/i.test((document.activeElement || {}).tagName || '') || (document.activeElement && document.activeElement.isContentEditable);
    if ((e.key === 'k' && (e.ctrlKey || e.metaKey)) || (e.key === '/' && !typing)) { e.preventDefault(); open(true); el.input.select(); }
  });

  /* Prefetch the index when the browser is idle so the first search is instant */
  var conn = navigator.connection || {};
  if (!conn.saveData) {
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 2500); };
    window.addEventListener('load', function () { idle(function () { loadIndex().catch(function () {}); }, { timeout: 6000 }); });
  }
  el.bar.addEventListener('mouseenter', function () { loadIndex().catch(function () {}); }, { once: true });
  el.bar.addEventListener('touchstart', function () { loadIndex().catch(function () {}); }, { once: true, passive: true });

  /* ---------------------------------------------------------------- voice */
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (el.voice && SR) {
    el.voice.hidden = false;
    var rec = null;
    el.voice.addEventListener('click', function () {
      if (rec) { rec.stop(); return; }
      rec = new SR();
      rec.lang = cfg.locale === 'ar' ? 'ar-JO' : 'en-US';
      rec.interimResults = true; rec.maxAlternatives = 1;
      el.voice.classList.add('is-listening');
      var prevPh = el.input.placeholder; el.input.placeholder = T.listening;
      if (!isOpen()) open(false);
      rec.onresult = function (ev) {
        var txt = Array.prototype.map.call(ev.results, function (r) { return r[0].transcript; }).join(' ');
        el.input.value = txt; run(txt);
      };
      rec.onend = rec.onerror = function () { el.voice.classList.remove('is-listening'); el.input.placeholder = prevPh; rec = null; if (el.input.value) remember(el.input.value); };
      rec.start();
    });
  }

  /* -------------------------------------------------------- photo search */
  function clearPhoto() { el.photo.hidden = true; state.exactId = null; if (!state.photo) return; state.photo = null; el.photo.classList.remove('is-busy'); }
  function downscale(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var max = 640, s = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(img.naturalWidth * s)); c.height = Math.max(1, Math.round(img.naturalHeight * s));
        var ctx = c.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height); ctx.drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL('image/jpeg', 0.82));
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('bad image')); };
      img.src = url;
    });
  }
  /* Words a product must contain to belong to the category the AI saw (stops "black case" from showing black cables) */
  var CAT_WORDS = {
    'phone case': ['case', 'cover'], 'screen protector': ['screen', 'glass', 'protector'], 'camera lens protector': ['lens', 'camera protector'],
    'charger': ['charger', 'adapter', 'wall'], 'charging cable': ['cable'], 'power bank': ['power bank', 'powerbank', 'battery'],
    'magsafe power bank': ['power bank', 'powerbank', 'battery'], 'wireless charger': ['wireless', 'charging stand', 'charging pad'],
    'earbuds': ['earbud', 'airpods', 'buds', 'earphone', 'tws'], 'headphones': ['headphone', 'headset'], 'speaker': ['speaker'],
    'smart watch': ['smart watch', 'smartwatch', 'watch'], 'watch band': ['band', 'strap', 'loop', 'bracelet'], 'watch protector': ['watch case', 'protector', 'bumper'],
    'car holder': ['car holder', 'car mount', 'holder', 'mount'], 'car charger': ['car charger'], 'ipad case': ['ipad', 'tablet'], 'ipad pencil': ['pencil', 'stylus'],
    'keyboard': ['keyboard'], 'mouse': ['mouse'], 'laptop bag': ['laptop', 'bag', 'sleeve'], 'laptop sleeve': ['sleeve', 'laptop'], 'backpack': ['backpack'],
    'pouch': ['pouch'], 'crossbody bag': ['crossbody', 'bag'], 'wallet': ['wallet', 'card holder'], 'ring light': ['ring light', 'light'],
    'microphone': ['microphone', 'mic'], 'tripod': ['tripod', 'selfie stick'], 'gimbal': ['gimbal', 'stabilizer'], 'camera': ['camera'],
    'smart tag': ['tag', 'tracker'], 'phone stand': ['stand', 'holder'], 'adapter': ['adapter', 'hub', 'otg'], 'mobile stamp': ['stamp'],
    'phone charm': ['charm', 'strap', 'chain', 'lanyard'], 'airpods case': ['airpods'], 'macbook case': ['macbook'],
    'waterproof phone case': ['waterproof'], 'security camera': ['camera'], 'hair dryer': ['dryer', 'hair'], 'vacuum cleaner': ['vacuum']
  };
  function inCategory(d, cat) {
    var words = CAT_WORDS[cat]; if (!words) return true;
    var text = ' ' + baseNorm(d.title + ' ' + (d.type || '')) + ' ';
    return words.some(function (w) { return text.indexOf(' ' + w) > -1; });
  }
  function gate(res, cat, limit) {
    if (!res || !res.total || !CAT_WORDS[cat]) return res;
    var all = res.all.filter(function (d) { return inCategory(d, cat); });
    return { all: all, items: all.slice(0, limit), total: all.length, relaxed: res.relaxed, tokens: res.tokens, correction: null };
  }
  /* Try the AI's terms from most to least specific; keep only products of the category it saw */
  function runPhotoTerms(p) {
    var cat = p.category, lim = state.shown;
    /* product titles say "iPhone … Case", not "phone case": drop filler words so "pink phone case" finds pink cases */
    var FILLER = /\b(phone|mobile|smartphone|cell|with|and|for|the|a|an)\b/g;
    var tried = [];
    var txt = baseNorm(p.text || '').replace(/\s+/g, ' ').trim();
    var textTerms = txt.length >= 3 ? [txt] : [];
    textTerms.concat([p.query]).concat(p.terms || []).concat(cat ? [cat] : []).forEach(function (t) {
      if (!t) return;
      var short = baseNorm(t).replace(FILLER, ' ').replace(/\s+/g, ' ').trim();
      [t, short].forEach(function (x) { if (x && tried.indexOf(x) < 0) tried.push(x); });
    });
    /* every AI search "votes" for the products it finds; products found by several searches
       (e.g. "pink case" + "beads case" + "pearl case") rise to the top */
    var votes = new Map(), loose = null, relaxedHit = null, res = null;
    state.textExact = null;
    tried.forEach(function (t, i) {
      var r = search(t, 400);
      if (r.total && !loose) loose = r;
      var g = gate(r, cat, lim);
      if (!g || !g.total) return;
      if (r.relaxed) { if (!relaxedHit) relaxedHit = g; return; }
      var w = 1 / (1 + i * 0.25);
      if (textTerms.length && t === textTerms[0]) {
        w = 4;   /* the brand/model written in the photo is the strongest clue */
        if (g.total <= 2) state.textExact = String(g.all[0].id);   /* e.g. "acefast m47" → exactly one product */
      }
      g.all.slice(0, 80).forEach(function (d, pos) { votes.set(d, (votes.get(d) || 0) + w * (1 - pos / 160)); });
    });
    var lookWords = baseNorm(p.look || '').split(' ').filter(function (x) { return x.length > 2 && !/^(and|with|the|for|case|phone|cover|color|colour)$/.test(x); });
    if (votes.size) {
      var ranked = Array.from(votes.keys()).map(function (d) {
        var v = votes.get(d), t = ' ' + d.nt + ' ';
        lookWords.forEach(function (x) { if (t.indexOf(' ' + x) > -1 || t.indexOf(' ' + x.replace(/(ed|s)$/, '')) > -1) v += 0.6; });
        return { d: d, v: v };
      }).sort(function (a, b) { return b.v - a.v; }).map(function (x) { return x.d; });
      res = { all: ranked, items: ranked.slice(0, lim), total: ranked.length, relaxed: false, tokens: [], correction: null };
    }
    if (!res && relaxedHit) { res = relaxedHit; res.relaxed = true; }
    if (!res && loose) { res = loose; res.items = loose.all.slice(0, lim); res.relaxed = true; }
    /* the photo's color first: products that come in that color (title or color option) move to the top */
    var col = (baseNorm(p.query + ' ' + (p.terms || []).join(' ')).match(/\b(black|white|red|blue|green|pink|purple|gold|silver|gray|grey|brown|orange|yellow|clear|transparent|beige|navy)\b/) || [])[1];
    if (res && res.total && col) {
      var hasCol = function (d) {
        if ((' ' + d.nt + ' ').indexOf(' ' + col) > -1) return true;
        return Object.keys(d.opts || {}).some(function (k) { return (d.opts[k] || []).some(function (v) { return baseNorm(v).indexOf(col) > -1; }); });
      };
      var yes = [], no = [];
      res.all.forEach(function (d) { (hasCol(d) ? yes : no).push(d); });
      res.all = yes.concat(no); res.items = res.all.slice(0, lim);
    }
    if (!res || !res.total) res = search(cat || 'case', lim);
    /* visual matches (same look as the photo) go first, then the text results */
    var vis = visualMatches(p);
    if (vis.length) {
      var seen = {};
      vis.forEach(function (d) { seen[d.id] = 1; });
      var rest = (res.all || res.items || []).filter(function (d) { return !seen[d.id]; });
      var all = vis.concat(rest);
      res = { all: all, items: all.slice(0, lim), total: all.length, relaxed: false, tokens: [], correction: null };
    }
    state.photoVis = vis;
    if (state.textExact) {
      var tx = (res.all || []).filter(function (d) { return String(d.id) === state.textExact; })[0];
      if (tx) {
        state.exactId = state.textExact;
        var a2 = [tx].concat(res.all.filter(function (d) { return d !== tx; }));
        res = { all: a2, items: a2.slice(0, lim), total: a2.length, relaxed: false, tokens: [], correction: null };
      }
    }
    renderResults(p.label, res);
    el.dym.hidden = true;
  }
  /* Visual fingerprints of all products (built once with the ?catchy-admin page), loaded on the first photo search */
  var VIS = null, visLoading = null;
  var VSTOP = /^(and|with|the|for|its|has|very|color|colour|colors|product|item|phone|mobile|case|cover|design|style|finish)$/;
  function vwords(str) {
    var out = [];
    baseNorm(str).split(' ').forEach(function (x) {
      if (x.length < 3 || VSTOP.test(x)) return;
      if (x.length > 5) x = x.replace(/ed$/, '');
      if (x.length > 4) x = x.replace(/(es|s)$/, '');
      if (out.indexOf(x) < 0) out.push(x);
    });
    return out;
  }
  function loadVis() {
    if (VIS) return Promise.resolve(VIS);
    if (!visLoading && WORKER) visLoading = fetch(WORKER + '/vis/all').then(function (r) { return r.json(); }).then(function (j) {
      var list = (j.v || []).map(function (r) { return { id: String(r[0]), cat: r[1], toks: vwords(r[2]) }; });
      var df = {}; list.forEach(function (x) { x.toks.forEach(function (t) { df[t] = (df[t] || 0) + 1; }); });
      var n = list.length || 1, idf = {};
      Object.keys(df).forEach(function (t) { idf[t] = Math.log(1 + n / df[t]); });
      list.forEach(function (x) { x.norm = Math.sqrt(x.toks.reduce(function (a, t) { return a + idf[t] * idf[t]; }, 0)) || 1; });
      VIS = { list: list, idf: idf };
      return VIS;
    }).catch(function () { visLoading = null; return null; });
    return visLoading || Promise.resolve(null);
  }
  /* Products whose fingerprint shares the most (and the rarest) look-words with the photo:
     "beads, pearls, bow" counts far more than "pink" */
  var byId = null;
  function visualMatches(p) {
    if (!VIS || !VIS.list.length || !IDX) return [];
    if (!byId) { byId = {}; IDX.docs.forEach(function (d) { byId[String(d.id)] = d; }); }
    var q = vwords((p.look || '') + ' ' + (p.text || ''));
    if (q.length < 2) return [];
    var idf = VIS.idf, qn = Math.sqrt(q.reduce(function (a, t) { return a + (idf[t] || 0) * (idf[t] || 0); }, 0)) || 1;
    var alts = p.alts || [];
    var scored = [];
    VIS.list.forEach(function (x) {
      var dot = 0;
      for (var i = 0; i < q.length; i++) if (idf[q[i]] && x.toks.indexOf(q[i]) > -1) dot += idf[q[i]] * idf[q[i]];
      if (!dot) return;
      if (x.cat !== p.category && alts.indexOf(x.cat) < 0) return;   /* never mix product types (no iPad case for a power bank) */
      var sc = dot / (qn * x.norm);
      if (x.cat !== p.category) sc *= 0.85;
      if (byId[x.id]) scored.push({ d: byId[x.id], s: sc });
    });
    scored.sort(function (a, b) { return b.s - a.s; });
    if (!scored.length) return [];
    var top = scored[0].s;
    return scored.filter(function (x) { return x.s >= Math.max(0.22, top * 0.72); }).slice(0, 12).map(function (x) { return x.d; });
  }
  /* Second look: ask the AI which of the top 4 is the very same product, and pin it first */
  function verifyExact(dataUrl, p) {
    var cands = (state.photoVis || []).slice(0, 4);
    if (!cands.length || !WORKER || state.exactId) return;
    timeout(fetch(WORKER + '/verify', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ image: dataUrl, ids: cands.map(function (d) { return String(d.id); }) }) }), 20000)
      .then(function (r) { return r.json(); })
      .then(function (v) {
        if (!v || !v.exact || state.photo !== p || !state.res) return;
        state.exactId = String(v.exact);
        var all = state.res.all || state.res.items, hit = all.filter(function (d) { return String(d.id) === state.exactId; })[0];
        if (!hit) return;
        all = [hit].concat(all.filter(function (d) { return d !== hit; }));
        var res = { all: all, items: all.slice(0, Math.max(state.res.items.length, state.shown)), total: all.length, relaxed: false, tokens: [], correction: null };
        renderResults(p.label, res);
        el.dym.hidden = true;
      }).catch(function () {});
  }
  function photoSearch(file) {
    if (!file || !/^image\//.test(file.type) || !WORKER) return;
    if (!isOpen()) open(false);
    el.input.value = ''; el.clear.hidden = false;
    state.photo = { label: '…' }; state.shown = baseShown();
    el.photo.hidden = false; el.photoThumb.hidden = false; el.photo.classList.add('is-busy');
    el.photoStatus.textContent = T.analyzing; el.photoTerms.innerHTML = '';
    el.home.hidden = true; el.results.hidden = true;
    var idxReady = loadIndex();
    loadVis();
    state.exactId = null;
    var sentImage = '';
    downscale(file).then(function (dataUrl) {
      el.photoThumb.src = dataUrl; sentImage = dataUrl;
      return timeout(fetch(WORKER + '/image', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ image: dataUrl, locale: cfg.locale }) }), 25000);
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { return Promise.all([idxReady, timeout(loadVis(), 4000).catch(function () { return null; })]).then(function () { return p; }); })
      .then(function (p) {
        if (!state.photo) return;
        state.photo = p;
        el.photo.classList.remove('is-busy');
        el.photoStatus.textContent = T.photoResult + ' ' + p.label;
        /* chips: the AI's searches, then "not right?" alternatives so a wrong guess is one tap away from the right products */
        el.photoTerms.innerHTML = [p.query].concat(p.terms || []).filter(function (t, i, a) { return t && a.indexOf(t) === i; }).slice(0, 4)
          .map(function (t) { return '<button type="button" class="cs-chip" data-cs-term="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') +
          (p.alts || []).map(function (t) { return '<button type="button" class="cs-chip cs-chip--alt" data-cs-term="' + esc(t) + '">' + esc(T.orMaybe || (cfg.locale === 'ar' ? 'أو' : 'or')) + ' ' + esc(t) + '?</button>'; }).join('');
        runPhotoTerms(p);
        verifyExact(sentImage, p);
        sendLog('📷 ' + (p.query || p.label), state.res ? state.res.total : -1, 'photo');
      })
      .catch(function () {
        el.photo.classList.remove('is-busy');
        el.photoStatus.textContent = T.photoFail;
        el.home.hidden = false;
      });
  }
  if (el.camera && el.file) {
    el.camera.addEventListener('click', function () {
      if (!WORKER) { /* photo search not connected yet: say so instead of failing silently */
        if (!isOpen()) open(false);
        el.photo.hidden = false; el.photoThumb.hidden = true; el.photo.classList.remove('is-busy');
        el.photoStatus.textContent = T.photoSoon || T.photoFail; el.photoTerms.innerHTML = '';
        return;
      }
      el.file.value = ''; el.file.click();
    });
    el.file.addEventListener('change', function () { photoSearch(el.file.files && el.file.files[0]); });
    el.photoClose.addEventListener('click', function () { clearPhoto(); run(''); });
    /* Drag & drop and paste a photo (desktop) */
    var dragDepth = 0;
    root.addEventListener('dragenter', function (e) { if (e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types, 'Files') > -1) { dragDepth++; if (!isOpen()) open(false); root.classList.add('is-dragging'); } });
    root.addEventListener('dragleave', function () { if (--dragDepth <= 0) { dragDepth = 0; root.classList.remove('is-dragging'); } });
    root.addEventListener('dragover', function (e) { e.preventDefault(); });
    root.addEventListener('drop', function (e) { e.preventDefault(); dragDepth = 0; root.classList.remove('is-dragging'); photoSearch(e.dataTransfer.files[0]); });
    el.input.addEventListener('paste', function (e) {
      var f = Array.prototype.find.call((e.clipboardData && e.clipboardData.files) || [], function (x) { return /^image\//.test(x.type); });
      if (f) { e.preventDefault(); photoSearch(f); }
    });
  } else if (el.photoClose) {
    el.photoClose.addEventListener('click', function () { clearPhoto(); run(''); });
  }


  /* ------------------------------------------------ admin: build the visual index
     Open your store with ?catchy-admin at the end of the address, enter your ADMIN_KEY, press Start.
     It gives every product photo an AI "fingerprint" so photo search can find the exact product.
     Run it again any time: only new or changed products are processed. */
  if (/[?&]catchy-admin\b/.test(location.search) && WORKER) {
    var A = document.createElement('div');
    A.style.cssText = 'position:fixed;z-index:2147483646;right:16px;bottom:16px;width:min(360px,calc(100vw - 32px));background:#fff;border:1px solid #e6e6e8;border-radius:16px;box-shadow:0 20px 50px rgba(0,0,0,.18);padding:18px;font:14px/1.45 system-ui,sans-serif;color:#222';
    A.innerHTML = '<b style="font-size:16px">Photo search · visual index</b>' +
      '<p style="margin:6px 0 12px;color:#666">Gives every product photo an AI fingerprint so photo search finds the exact product. Keep this tab open while it runs.</p>' +
      '<input type="password" placeholder="ADMIN_KEY" style="width:100%;box-sizing:border-box;height:40px;border:1px solid #ddd;border-radius:10px;padding:0 12px;margin-bottom:10px">' +
      '<div style="height:8px;background:#f1f1f2;border-radius:4px;overflow:hidden"><i style="display:block;height:100%;width:0;background:#0e98ba;transition:width .3s"></i></div>' +
      '<p class="st" style="margin:8px 0 12px;color:#444">Ready.</p>' +
      '<button type="button" style="height:42px;padding:0 20px;border:0;border-radius:10px;background:#0e98ba;color:#fff;font-weight:600;cursor:pointer">Start</button>';
    document.body.appendChild(A);
    var aKey = A.querySelector('input'), aBar = A.querySelector('i'), aSt = A.querySelector('.st'), aBtn = A.querySelector('button');
    try { aKey.value = sessionStorage.getItem('cs-admin-key') || ''; } catch (e) {}
    var running = false, okN = 0, badN = 0, total = 0, todo = [], lastErr = '', aiFails = 0, t0 = 0;
    var show = function (msg) {
      var done = total - todo.length;
      aBar.style.width = (total ? Math.round(done / total * 100) : 0) + '%';
      var mins = okN > 5 ? Math.round((Date.now() - t0) / okN * todo.length / 60000) : null;
      aSt.innerHTML = msg || ('<b>' + okN + '</b> done · ' + badN + ' skipped · <b>' + todo.length + '</b> left' + (mins != null ? ' · about ' + mins + ' min' : '') + (lastErr ? '<br><small style="color:#b44">Last problem: ' + esc(lastErr) + '</small>' : ''));
    };
    var stop = function (msg) { running = false; aBtn.textContent = 'Start'; show(msg); };
    var worker = function () {
      if (!running) return Promise.resolve();
      var batch = todo.splice(0, 3);
      if (!batch.length) return Promise.resolve();
      return fetch(WORKER + '/vis/index', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ key: aKey.value.trim(), items: batch.map(function (d) { return { id: String(d.id), img: d.img }; }) }) })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, j: j }; }); })
        .then(function (x) {
          if (x.status === 403) { todo = batch.concat(todo); return stop('Wrong ADMIN_KEY.'); }
          (x.j.results || []).forEach(function (r) { if (r.ok) { okN++; aiFails = 0; } else { badN++; lastErr = r.error || 'error'; if (/neuron|daily|limit|quota|4006|capacity|AiError/i.test(lastErr)) aiFails++; } });
          if (aiFails >= 6) { todo = batch.concat(todo); return stop('Cloudflare\'s free daily AI allowance looks used up. Come back tomorrow and press Start — it continues where it stopped.<br><small style="color:#b44">' + esc(lastErr) + '</small>'); }
          show();
          return worker();
        })
        .catch(function (e) { lastErr = String(e && e.message || e); todo = batch.concat(todo); show(); return new Promise(function (r) { setTimeout(r, 3000); }).then(worker); });
    };
    aBtn.addEventListener('click', function () {
      if (running) return stop('Paused. Press Start to continue.');
      var key = aKey.value.trim(); if (!key) return show('Enter your ADMIN_KEY first.');
      try { sessionStorage.setItem('cs-admin-key', key); } catch (e) {}
      running = true; aBtn.textContent = 'Pause'; show('Checking which products are already done…');
      Promise.all([loadIndex(), fetch(WORKER + '/vis/status?key=' + encodeURIComponent(key)).then(function (r) { return r.json().then(function (j) { return { status: r.status, j: j }; }); })])
        .then(function (x) {
          var st = x[1];
          if (st.status === 403) return stop('Wrong ADMIN_KEY.');
          var done = {}; (st.j.done || []).forEach(function (r) { done[r[0]] = r[1]; });
          todo = IDX.docs.filter(function (d) { return d.img && done[String(d.id)] !== d.img; })
            .sort(function (a, b) { return (/case|cover/i.test(b.title) ? 1 : 0) - (/case|cover/i.test(a.title) ? 1 : 0) || a.rank - b.rank; });
          total = todo.length + Object.keys(done).length; okN = 0; badN = 0; t0 = Date.now();
          if (!todo.length) return stop('All ' + total + ' products are already indexed. ✓');
          show();
          return Promise.all([worker(), worker()]).then(function () { if (running && !todo.length) stop('Finished ✓ ' + okN + ' products indexed' + (badN ? ', ' + badN + ' skipped (press Start again to retry them)' : '') + '.'); });
        })
        .catch(function (e) { stop('Could not start: ' + esc(String(e && e.message || e))); });
    });
  }

  /* Public API — used by the search results page (catchy-search-results.js) */
  window.CatchySearch = {
    ready: loadIndex, query: function (q) { return search(q, 1e9); }, docs: function () { return IDX ? IDX.docs : []; },
    money: money, esc: esc, highlight: highlight, imgUrl: imgUrl, norm: baseNorm, tokens: tokens, productUrl: productUrl,
    remember: remember, log: sendLog, cfg: cfg,
    open: open, close: close, search: function (q) { return IDX ? search(q, 8) : null; }, reload: function () { IDX = null; loading = null; try { localStorage.removeItem('cs-index:' + cfg.locale + ':v3'); } catch (e) {} return loadIndex(); } };
  /* Clicked or typed before this script loaded? Catch up straight away. */
  if (document.activeElement === el.input) open(false);
  document.dispatchEvent(new CustomEvent('catchy-search:ready'));
})();